// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3b67V","label":"LabeledBox_label__FHIfZ"};